import { render } from "./plus-icon.vue.js?vue&type=template&id=41565151!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./plus-icon.vue?vue&type=template&id=41565151"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__